import React, { useState } from 'react';
import { SearchIcon, CalendarIcon, EyeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { allNews } from '../data/mockData';
export function NewsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredNews = allNews.filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()) || item.description.toLowerCase().includes(searchTerm.toLowerCase()));
  return <main className="min-h-screen bg-gray-50" data-id="element-480">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-purple-800 to-purple-600 text-white py-16 px-4" data-id="element-481">
        <div className="max-w-4xl mx-auto text-center" data-id="element-482">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-483">Latest News</h1>
          <p className="text-xl text-purple-100" data-id="element-484">
            Stay updated with the latest from Nakuru's creative community
          </p>
        </div>
      </section>

      <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-485">
        {/* Search */}
        <div className="bg-white rounded-xl shadow-md p-4 mb-8" data-id="element-486">
          <div className="relative" data-id="element-487">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-488" />
            <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search news..." className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-489" />
          </div>
        </div>

        {/* Featured Article */}
        {filteredNews.length > 0 && <div className="bg-white rounded-xl shadow-md overflow-hidden mb-8" data-id="element-490">
            <div className="md:flex" data-id="element-491">
              <div className="md:w-1/2" data-id="element-492">
                <img src={filteredNews[0].image} alt={filteredNews[0].title} className="w-full h-64 md:h-full object-cover" data-id="element-493" />
              </div>
              <div className="md:w-1/2 p-6 flex flex-col justify-center" data-id="element-494">
                <span className="text-purple-600 text-sm font-medium mb-2" data-id="element-495">
                  Featured Article
                </span>
                <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-496">
                  {filteredNews[0].title}
                </h2>
                <p className="text-gray-600 mb-4" data-id="element-497">
                  {filteredNews[0].description}
                </p>
                <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4" data-id="element-498">
                  <div className="flex items-center space-x-1" data-id="element-499">
                    <CalendarIcon className="w-4 h-4" data-id="element-500" />
                    <span data-id="element-501">{filteredNews[0].createdAt}</span>
                  </div>
                  <div className="flex items-center space-x-1" data-id="element-502">
                    <EyeIcon className="w-4 h-4" data-id="element-503" />
                    <span data-id="element-504">{filteredNews[0].views} Views</span>
                  </div>
                </div>
                <Link to="#" className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-medium transition-colors w-fit" data-id="element-505">
                  Read More
                </Link>
              </div>
            </div>
          </div>}

        {/* Results Count */}
        <p className="text-gray-600 mb-6" data-id="element-506">
          Showing {filteredNews.length}{' '}
          {filteredNews.length === 1 ? 'article' : 'articles'}
        </p>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-507">
          {filteredNews.slice(1).map(item => <article key={item.id} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-508">
              <div className="h-48 overflow-hidden" data-id="element-509">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-510" />
              </div>
              <div className="p-5" data-id="element-511">
                <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2" data-id="element-512">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-513">
                  {item.description}
                </p>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4" data-id="element-514">
                  <div className="flex items-center space-x-1" data-id="element-515">
                    <CalendarIcon className="w-4 h-4" data-id="element-516" />
                    <span data-id="element-517">{item.createdAt}</span>
                  </div>
                  <div className="flex items-center space-x-1" data-id="element-518">
                    <EyeIcon className="w-4 h-4" data-id="element-519" />
                    <span data-id="element-520">{item.views}</span>
                  </div>
                </div>
                <Link to="#" className="block w-full text-center bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg font-medium transition-colors" data-id="element-521">
                  Read More
                </Link>
              </div>
            </article>)}
        </div>

        {filteredNews.length === 0 && <div className="text-center py-12" data-id="element-522">
            <p className="text-gray-500 text-lg" data-id="element-523">
              No news articles found matching your search.
            </p>
          </div>}
      </section>
    </main>;
}